export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PDS_BANCA_ENG-f580b71d892ff8cfabe617b9cc9e9725.pdf";